<template>
    <div class="app-container">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/zltszhfw/bzfw' }">标准服务</el-breadcrumb-item>
                    <el-breadcrumb-item>一对一定制式标准化技术服务</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row class="content">
            <el-row>
                <el-col :span="12" class="box-title">
                    <span>服务申请</span>
                </el-col>
                <el-col :span="12" class="box-title_b"><span>咨询服务电话：0631-3859960、3859961   服务人员姓名：林宇春、潘盛南</span>
                </el-col>
                <el-divider></el-divider>
            </el-row>

            <div class="form-div">
                <el-form ref="form" :model="form" :rules="rules" label-width="250px" label-position="right">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="单位名称:" prop="entname">
                                <span>{{form.entname}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="统一社会信用代码:" prop="uniscid">
                                <span>{{form.uniscid}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="联系人姓名:" prop="linkman">
                                <el-input v-model="form.linkman" clearable placeholder="请输入联系人姓名"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人电话:" prop="linktel">
                                <el-input v-model="form.linktel" clearable placeholder="请输入联系人电话"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="联系地址:" prop="linkaddr">
                                <el-input v-model="form.linkaddr" clearable placeholder="请输入联系地址" disabled/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="服务事项:" prop="serviceItem">
                                <el-select v-model="form.serviceItem" size="medium" clearable width="100%">
                                    <el-option
                                            v-for="item in ydydzfwsxOptions"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="服务事项综述:" prop="serviceContent">
                                <el-input v-model="form.serviceContent" clearable
                                          type="textarea"
                                          :autosize="{ minRows: 2, maxRows: 5}"
                                          placeholder="请输入服务事项综述">
                                </el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                                <el-checkbox v-model="promise">我承诺：我所填写的申请信息真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任。
                                </el-checkbox>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="24" class="btn">
                            <el-button type="info" @click="submitForm('N')" :loading="btnload">保 存</el-button>
                            <el-button type="primary" @click="submitForm('Y')" :disabled="!promise" :loading="btnload">
                                提交并申请
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24"
                                style="margin-top: 1.875rem;margin-left:1.875rem;text-align: left;color: #959595;">
                            <span>注：保存后的信息可以再次编辑，提交并申报后的信息不可更改，提交申报后需等待审核。</span>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-row>

    </div>
</template>

<script>
    import {
        list1to1sqxx, get1to1sqxx, del1to1sqxx, add1to1sqxx, update1to1sqxx, export1to1sqxx
    } from "@/api/zlts/bzfw/1to1sqxx";
    import { getEntInfo} from "@/api/xwqy/rzsqsx";
    export default {
        name: "apply",
        data() {
            return {
                ydydzfwsxOptions: [],
                promise: false,
                btnload: false,
                form: {
                    entname: undefined,
                    uniscid: undefined,
                    linkman: undefined,
                    linktel: undefined,
                    linkaddr: undefined,
                    serviceItem: undefined,
                    serviceContent: undefined,
                    status: undefined,
                    ywFwjgRecid: undefined,
                    orgcode: undefined,
                },
                rules: {
                    entname: [{
                        required: true,
                        message: '请输入单位名称',
                        trigger: 'blur'
                    }],
                    uniscid: [{
                        required: true,
                        message: '请输入统一社会信用代码',
                        trigger: 'blur'
                    }],
                    linkman: [{
                        required: true,
                        message: '请输入联系人姓名',
                        trigger: 'blur'
                    }],
                    linktel: [{
                        required: true,
                        message: '请填写正确的联系人电话',
                        trigger: 'blur',
                        pattern: /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/,
                    }],
                    linkaddr: [{
                        required: true,
                        message: '请输入联系地址',
                        trigger: 'blur'
                    }],
                    serviceItem: [
                        {required: true, message: '请选择服务事项', trigger: 'change'}
                    ],
                    serviceContent: [
                        {required: true, message: '请输入服务事项综述', trigger: 'blur'}
                    ],
                },
                recid: undefined,
				uuid:undefined
            }
        },
        created() {
            let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
            if (ssessionLoginUser != null && ssessionLoginUser != undefined) {
				this.loginUser = ssessionLoginUser.user;
                this.form.entname = this.loginUser.corname;
                this.form.uniscid = this.loginUser.cornumber;
                this.form.orgcode = this.loginUser.county;
                //请求获取一企一档内容
                getEntInfo(this.loginUser.ywFwjgRecid).then(response => {
                    this.form.linkaddr = response.dom;
                    this.form.linkman = response.llr;
                    this.form.linktel = response.llrtel;
                });
				//----【】需要修改为recid
				this.ywFwjgRecid = this.loginUser.ywFwjgRecid;
            }
            this.getDicts("yw_ydydzfwsx_type").then(response => {
                this.ydydzfwsxOptions = response.data;
            });
            this.recid = this.$route.params && this.$route.params.recid;
            this.getDetail();
        },
        methods: {
            checkPhone(){
                let mobile = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/ // 最新16手机正则
                let value = this.form.linktel;
                if (value !== null && value !==undefined && value !==''){
                    if(!mobile.test(value)){
                        this.msgWarning("您输入的联系电话格式不正确，请重新输入！");
                        return false;
                    }else{
                        return true;
                    }
                }else{
                    return true;
                }
            },
            getDetail() {
                if (this.recid != null && this.recid != undefined) {
                    this.reset();
                    const recid = this.recid;
                    get1to1sqxx(recid).then(response => {
                        this.form = response.data;
                    });
                }
            },
            toPage(url) {
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            reset() {
                this.form = {
                    recid: undefined,
                    linkman: undefined,
                    linktel: undefined,
                    linkaddr: undefined,
                    serviceItem: undefined,
                    serviceContent: undefined,
                    ywSaveStatus: undefined,
                };
                this.resetForm("form");
            },
            submitForm(status) {
				this.form.ywFwjgRecid = this.loginUser.ywFwjgRecid;
				this.tosubmitForm(status);
                
            },
            /** 提交按钮 */
            tosubmitForm(status) {
				if (this.utils.isLoginTimeout()) {
					this.form.ywSaveStatus=status;
					this.$refs["form"].validate(valid => {
					    if (valid && this.checkPhone()) {
					        if (this.promise) {
								this.form.status = status =='Y' ?"1" :"0";
					            this.$confirm(`是否${status =='Y' ?"提交" :"保存"}?`, '提示', {
					                confirmButtonText: '确定',
					                cancelButtonText: '取消',
					                type: 'warning'
					            }).then(() => {
									this.btnload = true;
					                this.saveForm();
					            })
					        } else {
					            this.msgError("请选择承诺");
					        }
					    }
					})
				} else {
					this.$confirm('登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
            },
            saveForm(status) {
                let message = status == 'Y' ? '提交申请成功' : '保存成功';
                if (this.form.recid != undefined) {
                    update1to1sqxx(this.form).then(response => {
                        if (response.code === 200) {
                            this.msgSuccess(message);
                            this.reset();
                            this.toPage('/main/zltszhfw/bzfw');
                        } else {
                            this.msgError(response.msg);
                        }
                        this.btnload = false;
                    });
                } else {
                    add1to1sqxx(this.form).then(response => {
                        if (response.code === 200) {
                            this.msgSuccess(message);
                            this.reset();
                            this.toPage('/main/zltszhfw/bzfw');
                        } else {
                            this.msgError(response.msg);
                        }
                        this.btnload = false;
                    });
                }
            },
        }
    }
</script>

<style scoped="scoped">
    .app-container {
        padding: 0px 15px 20px;
        background-color: #ffffff;
    }

    .navigation {
        padding: 20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .content {
        border: 1px solid #cccccc;
        padding: 20px 60px;
    }

    .box-title {
        color: #4A8DEC;
        font-size: 1.25rem;
        font-weight: bold;
        text-align: left;
        margin-bottom: 10px;
    }

    .box-title_b {
        color: #F8A618;
        font-size: 0.85rem;
        font-weight: bold;
        text-align: left;
        margin-bottom: 10px;
    }

    /deep/ .el-checkbox__label {
        color: #ffaa20;
    }

    /deep/ .el-form-item__label {
        padding: 0 50px 0 0;
    }

    /deep/ .el-form-item__content {
        text-align: left;
    }

    .form-div .form-box-title {
        display: flex;
        height: 1.5625rem;
        line-height: 1.5625rem;
        font-size: 1.0625rem;
        /* padding-bottom: 0.4375rem; */
    }

    .form-div .form-box-title img {
        width: 1rem;
        height: 1rem;
        /* margin: 0.625rem 0 0.8125rem; */
    }

    .form-div .form-box-title .form-box-flex {
        flex: 1;
        padding-left: 0.625rem;
        text-align: left;
    }

    .remarks {
        text-align: right;
        color: #999999;
        font-size: 12px;
        vertical-align: middle;
        line-height: 2.25rem;
    }

    btn {
        text-align: center;
    }

    .btn .el-button + .el-button {
        margin-left: 30px;
    }

</style>
